export default [
    {
        category: 'オフィス',
        data: [
            {
                title: '調査対象',
                content:`
原則として延床面積1,000坪以上、かつ新耐震基準に準拠した賃貸オフィスビル`,
            },
            {
                title: 'グレードA',
                content: `
原則としてオフィス集積度の高い地域（*）に所在する基準階面積350坪以上（東京は500坪以上）、貸付総面積6,500坪以上、延床面積10,000坪以上、概ね築15年未満の賃貸オフィスビル
上記基準を満たすものとするが、ビルのランドマーク性、スペック等を総合的に勘案して選定
（*）東京：主要5区を中心とする
大阪：北区、中央区、淀川区を中心とする
名古屋：中村区、中区、東区、西区を中心とするオフィス集積度の高い地域`,
            },
            {
                title: 'グレードAマイナス',
                content: `
東京23区内に所在する基準階面積250坪以上、貸付総面積4,500坪以上、延床面積7,000坪以上、新耐震基準に準拠した賃貸オフィスビル（グレードAは除く）`,
            },
            {
                title: 'グレードB',
                content: `
▪ 東京
原則としてオフィス集積度が認められる地域に所在する基準階面積200坪以上、延床面積2,000以上7,000坪未満、かつ新耐震基準に準拠した賃貸オフィスビル（グレードA,グレードAマイナスは除く）
▪ 大阪・名古屋
原則としてオフィス集積度が認められる地域に所在する延床面積2,000以上、かつ新耐震基準に準拠した賃貸オフィスビル（グレードAは除く）`,
            },
            {
                title: '想定成約賃料',
                content: `
対象ビルのサンプル調査に基づく想定成約賃料（共益費含む、フリーレント等のインセンティブは考慮しない）`,
            },
            {
                title: '空室率',
                content: `
空室は集計時点で即入居可能であるものを対象`,
            },
            {
                title: '募集空室率',
                content: `
即入居可能な空室に加え、1年以内に即入居可能となる空室予定区画、及び、1年以内に竣工予定のビルにおける募集区画を足して算出した空室率`,
            },
            {
                title: '新規供給面積',
                content: `
各期間内に竣工したビルの賃貸面積`,
            },
            {
                title: '新規需要面積',
                content: `
各期の稼働床面積（テナント使用面積）の前期差`,
            },
            {
                title: 'プライムイールド',
                content: `
プライムエリアに所在するトップクラスの物件の想定利回り。取引や市場動向に基づきCBREが推定した数値で、将来の賃料上昇は加味していない`,
            },
        ]
        
    },
    {
        category: 'インダストリアルandロジスティクス',
        data: [
            {
                title: '調査対象',
                content: `
対象都市に所在する、主な用途が倉庫である一般募集された施設`,
            },
            {
                title: '大型マルチテナント型物流施設（LMT）',
                content: `
▪ 対象地域
首都圏：東京都、千葉県、埼玉県、神奈川県 
近畿圏：大阪府、兵庫県、京都府 
中部圏：愛知県 
福岡圏：福岡県、佐賀県
▪ 対象施設
首都圏、近畿圏：延床面積10,000坪以上
中部圏、福岡圏：延床面積5,000坪以上
原則として、開発当時において複数テナント利用を前提として企画・設計された施設`,
            },
            {
                title: '中大型施設',
                content: `
▪ 対象地域
東京、千葉、埼玉、神奈川、愛知、大阪、福岡の各都道府県対象
▪ 対象施設
1棟あたりの募集面積1,000坪以上の物流施設`,
            },
            {
                title: '実質賃料指数',
                content: `
新規契約する場合、調査時点で成約すると想定される賃料（共益費含む）
契約期間、フリーレント期間を考慮した実質的な月額賃料を基に算出した指数`,
            },
            {
                title: '募集賃料',
                content: `
月額募集賃料の坪当たり単価（共益費を含まない）`,
            },
            {
                title: '空室率',
                content: `
空室は集計時点で即入居可能であるものを対象（新築施設は竣工済みのものが対象）`,
            },
            {
                title: 'プライムイールド',
                content: `
プライムエリアに所在するトップクラスの物件の想定利回り。取引や市場動向に基づきCBREが推定した数値で、将来の賃料上昇は加味していない`,
            },

        ]
    },
    {
        category: 'リテール',
        data: [
            {
                title: '調査対象',
                content: `
CBREが独自に設定した対象地`,
            },
            {
                title: 'プライム賃料',
                content: `
対象地のサンプル調査に基づく想定成約賃料（共益費を含み、フリーレント等のインセンティブは考慮しない）
ワンフロアの面積が200㎡程度の建物を想定、対象フロアは店舗ニーズの高い1階に限定`,
            },
            {
                title: '空室率',
                content: `
空室は集計時点で即入居可能であるものを対象（新築施設は竣工済みのものが対象）`,
            },
            {
                title: 'プライムイールド',
                content: `
プライムエリアに所在するトップクラスの物件の想定利回り。取引や市場動向に基づきCBREが推定した数値で、将来の賃料上昇は加味していない`,
            },
        ]
    }
]